import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { Collapse } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useState } from 'react';
import { getAvailableRoutes } from '../navigationUtils';
import styles from './DrawerListItem.module.css';
import Divider from '@mui/material/Divider';

const textColor = { color: 'var(--color-white)' };

function DrawerListItem({ route, listItemComponent, listItemAttributes, onClick, text, textStyles, Icon, heading }) {
    const location = useLocation();
    const additionalAttributes = { ...(listItemAttributes && { ...listItemAttributes }) };
    const isActive = location?.pathname === route;
    const classes = `${styles['navigationItem']} ${isActive ? ` ${styles['activeItem']}` : ''}`;

    return (
        <>
            {heading && <p className={styles.listItemHeading}>{heading}</p>}
            <ListItem
                className={styles.navigationItemContainer}
                disablePadding
                component={listItemComponent}
                onClick={onClick}
                {...additionalAttributes}
            >
                <ListItemButton className={classes}>
                    <ListItemIcon className={styles.navigationItemIcon}>{Icon && <Icon />}</ListItemIcon>
                    <ListItemText className={styles.navigationItemText} primary={text} sx={{ ...textColor, ...textStyles }} />
                </ListItemButton>
            </ListItem>
        </>
    );
}

export function FoldableDrawerListItem({ text, textStyles, childListItems, user, onClick, Icon }) {
    const [open, setOpen] = useState(false);
    const toggleOpen = () => setOpen(!open);

    const children = getAvailableRoutes(childListItems, user, onClick);
    return (
        <div onClick={toggleOpen}>
            <Divider sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }} />
            <ListItem className={styles.navigationItemContainer} disablePadding button>
                <ListItemButton className={styles.navigationItem}>
                    <ListItemIcon className={styles.navigationItemIcon}>{Icon && <Icon />}</ListItemIcon>
                    <ListItemText className={styles.navigationItemText} primary={text} sx={{ ...textColor, ...textStyles }} />
                    {open ? <ExpandLess sx={textColor} /> : <ExpandMore sx={textColor} />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" sx={{ paddingLeft: '1rem' }}>
                {children}
            </Collapse>
        </div>
    );
}

export default DrawerListItem;
